module.exports = __webpack_public_path__ + "static/img/st.dafba84c.svg";